import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { HeaderAdmin } from '../../../components/molecues';
import { SubjectEditModal, PhraseEditModal, SubjectPanel, VocabularyPanel, ChunkPanel } from '../../../containers/organisms';
import { PhraseAddAllModal } from '../../../containers/organisms/PhraseAddAllModal.jsx';
import { Button, LoadingView, Toast} from '../../../../common/components/atoms';

import { PopupMessage, POPUP_TYPE } from '../../../common/PopupMessage';
import { DialogMessage } from '../../../common/DialogMessage.jsx';

import { ModalDialog } from '../../../../common/components/molecues';

class SubjectManage extends Component {
    constructor(props) {
        super(props);

        this.refSubjectEditModal = React.createRef();
        this.refPhraseEditModal = React.createRef();
        this.refPhraseAddAllModal = React.createRef();
        this.refSubjectList = React.createRef();
        this.refVocabularyList = React.createRef();
        this.refChunkList = React.createRef();
        this.refToast = React.createRef();

        this.editSubject = {};
        this.editVocabulary = {};
        this.editChunk = {};

        this.loadingVocabulary =false;
        this.loadingChunk =false;

        this.intervalId = -1;
        this.state = {
            currentDate: new Date(),
            searchText: "",
            subjectID: "",
            displaySubjectEdit: false,
            displayPhraseEdit: false,
            displayPhraseAddAll: false,
            phraseEditType: 0,
            loading: false,
            displayDlg: false,
            deleteReady: null,
            deleteMode: 0,
            subjectKbn: "1",
        }
    }

    // stateの変化を監視
    // reducerの動きでloadingがtrueからfalseに切り替わったら
    // toastを表示する
    componentDidUpdate(prevProps, prevState) {
        if (prevState.loading && !this.state.loading) {
            this.setLoadEndToast();
        }
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.loading !== nextProps.loading) {
            return {
                loading: nextProps.loading,
            };
        }
        return null;
    }

    componentDidMount() {
        this.props.dispatch({
            type: "CheckMaintenance_Saga"
        });
        this.loadSubjectList(this.state.currentDate, this.state.subjectKbn);
    }
    onSuccessGetSubject = (subjects) => {
        let temp = [];
        for(let key in subjects) {
            if(!subjects[key].deleteFlg){
                temp.push(subjects[key]);
            }
        }

        temp = this.getSortedList(temp);
        for (let key in temp) {
            this.props.dispatch({
                type: "ChangeOrder_Saga",
                id: temp[key].id,
                order: temp[key].order,
                mode: 0,
                index: key,
                onSuccess: this.onSuccess,
                onFailure: this.onFailure,
            });
        }
        this.refSubjectList.current.set(temp);
        this.setState({
            subjects: temp,
        });
    }
    onFailure = (status, error) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
        this.setState({ displayDlg: false });
    }
    loadSubjectList = (date, subjectKbn) => {
            this.props.dispatch({
            type: "LoadStart"
        });
        this.refVocabularyList.current.set([]);
        this.refChunkList.current.set([]);

        this.setState({ subjectKbn: subjectKbn });

        const pDate = date.getFullYear() + "-" + ('0' + (date.getMonth() + 1)).slice(-2) + "-" + ('0' + date.getDate()).slice(-2);
        this.props.dispatch({
            type: "GetSubjectList_Saga",
            date: pDate,
            admin: true,
            subjectKbn: subjectKbn,
            onSuccess: this.onSuccessGetSubject,
            onFailure: this.onFailure,
        });
    }

    setLoadEndToast() {
        this.refToast.current.set(this.props.loadResult, this.props.afterLoadMessage);
    }

    onCilckBack = (e) => {
        this.props.history.push('/admin/trainer/top');
    }

    getSortedList(list) {
        list.sort((a, b) => {
            if (a.order < b.order) return -1;
            if (a.order > b.order) return 1;
            return 0;
        });
        let order = 0;
        for (let key in list) {
            list[key].order = order;
            order++;
        }
        return list;
    }

    onSuccessGetVocabulary = (list) => {
        this.loadingVocabulary = false;
        if(!this.loadingChunk) {
            this.props.dispatch({
                type: "LoadEnd"
            });
        }

        this.setVocabularyList(list);
    }
    onSuccessGetChunk = (list) => {
        this.loadingChunk = false;
        if(!this.loadingVocabulary) {
            this.props.dispatch({
                type: "LoadEnd"
            });
        }

        this.setChunkList(list);
    }

    onClickSubject = (e, subject) => {
        this.setState({ subjectID: subject.id });
        this.props.dispatch({
            type: "LoadStart"
        });
        this.loadingVocabulary = true;
        this.loadingChunk = true;

        this.props.dispatch({
            type: "GetVocabularyList_Saga",
            subjectID: subject.id,
            admin: 1,
            onSuccess: this.onSuccessGetVocabulary,
            onFailure: this.onFailure,
        });
        this.props.dispatch({
            type: "GetChunkList_Saga",
            admin: 1,
            subjectID: subject.id,
            onSuccess: this.onSuccessGetChunk,
            onFailure: this.onFailure,
        });
    }
    onClickSubjectEdit = (e, subject) => {
        e.preventDefault();
        e.stopPropagation();

        this.refSubjectEditModal.current.set(subject);
        this.setState({
            displaySubjectEdit: true,
        });
    }
    onClickSubjectDelete = (e, subject) => {
        e.preventDefault();
        e.stopPropagation();

        this.setState({
            displayDlg: true,
            deleteReady: subject,
            deleteMode: 0
        });
    }
    onClickSubjectHidden = (e, subject) => {
        e.preventDefault();
        e.stopPropagation();

        let flg;
        if(subject.releaseFlg) {
            flg = 0;
        } else {
            flg = 1;
        }
        this.props.dispatch({
            type: "LoadStart"
        });
        this.props.dispatch({
            type: "ChangeReleaseSubject_Saga",
            id: subject.id,
            releaseFlg: flg,
            onSuccess: this.onSuccessToggleRelase,
            onFailure: this.onFailure,
        });
    }
    onSuccessToggleRelase = (id, flg) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
        let subject = this.refSubjectList.current.get();
        for(let key in subject) {
            if(subject[key].id === id) {
                subject[key].releaseFlg = flg;
                break;
            }
        }
        this.refSubjectList.current.set(subject);
    }

    setSubjectList = (currentDate) => {
        this.setState({currentDate: currentDate});
        this.loadSubjectList(currentDate, this.state.subjectKbn);
    }

    onClickVocabularyEdit = (e, vocabulary) => {
        e.preventDefault();
        e.stopPropagation();

        this.refPhraseEditModal.current.set(vocabulary);
        this.setState({
            displayPhraseEdit: true,
            phraseEditType: 0,
        });
    }
    onClickVocabularyDelete = (e, vocabulary) => {
        e.preventDefault();
        e.stopPropagation();

        this.setState({
            displayDlg: true,
            deleteReady: vocabulary,
            deleteMode: 1
        });
    }
    setVocabularyList(list) {
        let temp = [];
        for(let key in list) {
            if(!list[key].deleteFlg){
                temp.push(list[key]);
            }
        }
        temp = this.getSortedList(temp);
        this.refVocabularyList.current.set(temp);
    }

    onClickChunkEdit = (e, chunk) => {
        e.preventDefault();
        e.stopPropagation();

        this.refPhraseEditModal.current.set(chunk);
        this.setState({
            displayPhraseEdit: true,
            phraseEditType: 1,
        });
    }
    onClickChunkDelete = (e, chunk) => {
        e.preventDefault();
        e.stopPropagation();

        this.setState({
            displayDlg: true,
            deleteReady: chunk,
            deleteMode: 2
        });
    }
    setChunkList(list) {
        let temp = [];
        for(let key in list) {
            if(!list[key].deleteFlg){
                temp.push(list[key]);
            }
        }
        temp = this.getSortedList(temp);
        this.refChunkList.current.set(temp);
    }

    onCilckAddSubject = (e) => {
        this.refSubjectEditModal.current.clear();
        this.refSubjectEditModal.current.setOrder(0);
        this.setState({
            subjectID: "",
            displaySubjectEdit: true,
        });
    }
    onCilckAddVocabulary = (e) => {
        if (this.state.subjectID) {
            this.refPhraseEditModal.current.clear(this.state.subjectID);
            this.refPhraseEditModal.current.setOrder(this.refVocabularyList.current.get().length);
            this.setState({
                displayPhraseEdit: true,
                phraseEditType: 0,
            });
        } else {
            this.refToast.current.set(0,
                PopupMessage({
                    type: POPUP_TYPE.SYS_ERROR,
                    message: "教材を選択してください。"
                })
            );
        }
    }
    onCilckAddAllVocabulary = (e) => {
        if (this.state.subjectID) {
            this.refPhraseAddAllModal.current.clear(this.state.subjectID);
            this.refPhraseAddAllModal.current.setOrder(this.refVocabularyList.current.get().length);
            this.setState({
                displayPhraseAddAll: true,
                phraseEditType: EDIT_TYPE.VOCABULARY,
            });
        } else {
            this.refToast.current.set(0,
                PopupMessage({
                    type: POPUP_TYPE.SYS_ERROR,
                    message: "教材を選択してください。"
                })
            );
        }
    }
    onCilckAddChunk = (e) => {
        if (this.state.subjectID) {
            this.refPhraseEditModal.current.clear(this.state.subjectID);
            this.refPhraseEditModal.current.setOrder(this.refChunkList.current.get().length);
            this.setState({
                displayPhraseEdit: true,
                phraseEditType: 1,
            });
        } else {
            this.refToast.current.set(0,
                PopupMessage({
                    type: POPUP_TYPE.SYS_ERROR,
                    message: "教材を選択してください。"
                })
            );
        }
    }
    onCilckAddAllChunk = (e) => {
        if (this.state.subjectID) {
            this.refPhraseAddAllModal.current.clear(this.state.subjectID);
            this.refPhraseAddAllModal.current.setOrder(this.refChunkList.current.get().length);
            this.setState({
                displayPhraseAddAll: true,
                phraseEditType: EDIT_TYPE.CHUNK,
            });
        } else {
            this.refToast.current.set(0,
                PopupMessage({
                    type: POPUP_TYPE.SYS_ERROR,
                    message: "教材を選択してください。"
                })
            );
        }
    }
    onClickSubjectSave = (e) => {
        this.loadSubjectList(this.state.currentDate, this.state.subjectKbn);
        this.setState({ displaySubjectEdit: false });
    }
    onClickSubjectEditCancel = (e) => {
        this.setState({ displaySubjectEdit: false });
    }

    onClickVocabularySave = (e) => {
        this.loadingVocabulary = true;
        this.props.dispatch({
            type: "GetVocabularyList_Saga",
            admin: 1,
            subjectID: this.state.subjectID,
            onSuccess: this.onSuccessGetVocabulary,
            onFailure: this.onFailure,
        });
        this.setState({ displayPhraseEdit: false });
    }
    onClickVocabularyAddAllSave = (e) => {
        this.loadingVocabulary = true;
        this.props.dispatch({
            type: "GetVocabularyList_Saga",
            admin: 1,
            subjectID: this.state.subjectID,
            onSuccess: this.onSuccessGetVocabulary,
            onFailure: this.onFailure,
        });
        this.setState({ displayPhraseAddAll: false });
    }
    onClickVocabularyEditCancel = (e) => {
        this.setState({ displayPhraseEdit: false });
    }
    onClickVocabularyAddAllCancel = (e) => {
        this.setState({ displayPhraseAddAll: false });
    }
    onClickChunkSave = (e) => {
        this.loadingChunk = true;
        this.props.dispatch({
            type: "GetChunkList_Saga",
            admin: 1,
            subjectID: this.state.subjectID,
            onSuccess: this.onSuccessGetChunk,
            onFailure: this.onFailure,
        });
        this.setState({ displayPhraseEdit: false });
    }
    onClickChunkAddAllSave = (e) => {
        this.loadingChunk = true;
        this.props.dispatch({
            type: "GetChunkList_Saga",
            admin: 1,
            subjectID: this.state.subjectID,
            onSuccess: this.onSuccessGetChunk,
            onFailure: this.onFailure,
        });
        this.setState({ displayPhraseAddAll: false });
    }
    onClickChunkEditCancel = (e) => {
        this.setState({ displayPhraseEdit: false });
    }
    onClickChunkAddAllCancel = (e) => {
        this.setState({ displayPhraseAddAll: false });
    }
    onSuccessDelete = (id) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
        this.setState({ displayDlg: false });
        if(this.state.deleteMode === 1) {
            let vocabulary = this.refVocabularyList.current.get();
            for(let key in vocabulary) {
                if(vocabulary[key].id === id) {
                    vocabulary[key].deleteFlg = 1;
                    break;
                }
            }
            this.refVocabularyList.current.set(vocabulary);
        } else if(this.state.deleteMode === 2) {
            let chunk = this.refChunkList.current.get();
            for(let key in chunk) {
                if(chunk[key].id === id) {
                    chunk[key].deleteFlg = 1;
                    break;
                }
            }
            this.refChunkList.current.set(chunk);
        } else {
            let subject = this.refSubjectList.current.get();
            for(let key in subject) {
                if(subject[key].id === id) {
                    subject[key].deleteFlg = 1;
                    break;
                }
            }
            this.refSubjectList.current.set(subject);
        }
    }

    onClickDeleteCnf = () => {
        this.props.dispatch({
            type: "LoadStart"
        });
        let saga;
        if(this.state.deleteMode === 1) {
            saga = "DeleteVocabulary_Saga";
        } else if(this.state.deleteMode === 2) {
            saga = "DeleteChunk_Saga";
        } else {
            saga = "DeleteSubject_Saga";
        }
        this.props.dispatch({
            type: saga,
            id: this.state.deleteReady.id,
            onSuccess: this.onSuccessDelete,
            onFailure: this.onFailure,
        });
    }
    onClickDlgCancel = () => {
        this.setState({ displayDlg: false });
    }
    createDlgProps = () => {
        let target;
        if(this.state.deleteMode === 1) {
            target = "ボキャブラリー";
        } else if(this.state.deleteMode === 2) {
            target = "チャンク";
        } else {
            target = "教材";
        }
        let message =(
            <div>
                この{target}を削除します。<br/>
                よろしいですか？
            </div>
        );
        return {
            display: this.state.displayDlg,
            contents: (
                <DialogMessage key="message" Title="確認" Message={message} />
            ),
            controls: {
                'OK': {
                    Color: '#000',
                    onClick: this.onClickDeleteCnf,
                },
                'キャンセル': {
                    Color: '#000',
                    onClick: this.onClickDlgCancel,
                },
            },
            type: 1,
        }
    }

    render() {
        const width = window.innerWidth + "px";
        const height = (window.innerHeight - 64 - 20) + "px";
        const itemHeight = (window.innerHeight - 64 - 20 - 64);
        const scrollHeight = (window.innerHeight - 64 - 20 - 20 - 64);
        const scrollHeightSubject = (window.innerHeight - 64 - 20 - 20 - 25 - 64);
        const propsHeader = {
            title: "教材管理",
            history: this.props.history,
        };
        const propsSubjectEdit = {
            subjectID: this.state.subjectID,
            display: this.state.displaySubjectEdit,
            onClickSave: this.onClickSubjectSave,
            onClickCancel: this.onClickSubjectEditCancel,
            editSubject: this.editSubject,
            dispatch: this.props.dispatch,
            permission: this.props.permission,
        };
        const propsPhraseEdit = {
            display: this.state.displayPhraseEdit,
            editType: this.state.phraseEditType,
            onClickSave: this.state.phraseEditType === 0 ?
                this.onClickVocabularySave :
                this.onClickChunkSave,
            onClickCancel: this.state.phraseEditType === 0 ?
                this.onClickVocabularyEditCancel :
                this.onClickChunkEditCancel,
            editPhrase: this.state.phraseEditType === 0 ?
                this.editVocabulary :
                this.editChunk,
            dispatch: this.props.dispatch,
            permission: this.props.permission,
        };
        const propsPhraseAddAll = {
            display: this.state.displayPhraseAddAll,
            editType: this.state.phraseEditType,
            onClickSave: this.state.phraseEditType === EDIT_TYPE.VOCABULARY ?
                this.onClickVocabularyAddAllSave :
                this.onClickChunkAddAllSave,
            onClickCancel: this.state.phraseEditType === EDIT_TYPE.VOCABULARY ?
                this.onClickVocabularyAddAllCancel :
                this.onClickChunkAddAllCancel,
            editPhrase: this.state.phraseEditType === EDIT_TYPE.VOCABULARY ?
                this.editVocabulary :
                this.editChunk,
            dispatch: this.props.dispatch,
            permission: this.props.permission,
        };
        const propsToast = {
            timeout: 2000,
            bottom: "55px",
            right: "100px",
        };
        const propsDlg = this.createDlgProps();

        return (
            <Body>
                <HeaderAdmin {...propsHeader}></HeaderAdmin>
                <Contents Width={width} Height={height}>
                    <Controls>
                        <Button
                            Color="#888888"
                            Width="100px"
                            onClick={this.onCilckBack}
                            text="戻る" />
                    </Controls>
                    <ItemsWrap>
                        <SubjectPanel ref={this.refSubjectList}
                            dispatch={this.props.dispatch}
                            itemHeight={itemHeight}
                            scrollHeight={scrollHeightSubject}
                            onClickSubject={this.onClickSubject}
                            setSubjectList={this.setSubjectList}
                            onClickSubjectHidden={this.onClickSubjectHidden}
                            onClickSubjectEdit={this.onClickSubjectEdit}
                            onClickSubjectDelete={this.onClickSubjectDelete}
                            onCilckAddSubject={this.onCilckAddSubject} 
                            loadSubjectList={this.loadSubjectList}/>
                        <VocabularyPanel ref={this.refVocabularyList}
                            dispatch={this.props.dispatch}
                            itemHeight={itemHeight}
                            scrollHeight={scrollHeight}
                            onClickVocabularyEdit={this.onClickVocabularyEdit}
                            onClickVocabularyDelete={this.onClickVocabularyDelete}
                            onCilckAddVocabulary={this.onCilckAddVocabulary}
                            onCilckAddAllVocabulary={this.onCilckAddAllVocabulary} />
                        <ChunkPanel ref={this.refChunkList}
                            dispatch={this.props.dispatch}
                            itemHeight={itemHeight}
                            scrollHeight={scrollHeight}
                            onClickChunkEdit={this.onClickChunkEdit}
                            onClickChunkDelete={this.onClickChunkDelete}
                            onCilckAddChunk={this.onCilckAddChunk}
                            onCilckAddAllChunk={this.onCilckAddAllChunk} />
                    </ItemsWrap>
                </Contents>
                <SubjectEditModal ref={this.refSubjectEditModal} {...propsSubjectEdit} />
                <PhraseEditModal ref={this.refPhraseEditModal} {...propsPhraseEdit} />
                <PhraseAddAllModal ref={this.refPhraseAddAllModal} {...propsPhraseAddAll} />
                <Toast ref={this.refToast} {...propsToast} />
                <ModalDialog name="delete-dialog" {...propsDlg} />
                <LoadingView Display={this.props.loading} />
            </Body>
        )
    }
}

const mapStateToProps = (store, ownProps) => {
    return {
        permission: store.login.user.permission,
        loading: store.loading.loading,
        afterLoadMessage: store.loading.message,
        loadResult: store.loading.state,
    }
};

const connectedSubjectManage = connect(mapStateToProps)(SubjectManage);
export { connectedSubjectManage as SubjectManage };

const Body = styled.div`
`;
const Contents = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    height: ${props => (props.Height)};
    padding-top: 20px;
`;
const Controls = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
`;

const ItemsWrap = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
    width: 90%;
`;
const EDIT_TYPE = {
    VOCABULARY: 0,
    CHUNK: 1,
};